import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    cellNumber: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'This field is required.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    startTime: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    eventExtra1: {
      validations: []
    },
    eventExtra2: {
      validations: [
        { type: 'required', message: 'This field is required.' }
      ]
    },
    category: {
      validations: []
    }, 
    eventExtra3: {
      validations: []
    },
    notes: {
        validations: []
      },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name: *',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name: *',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone: *',
           mapping: 'cellNumber'
         }
       ]
     },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email: *',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
            {
              type: 'label',
              size: 'Medium',
              label: 'Event Information',
              mapping: 'headerLabel',
              customClasses: ['header']
            },
          ]
        },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date: *',
              mapping: 'eventDate'
            }
          ]
        },
        {
          fields: [
            {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Event Time: *',
              options: [
                { label: '11:00 AM' , value: '11:00:00'},
                { label: '11:30 AM' , value: '11:30:00'},
                { label: '12:00 PM' , value: '12:00:00'},
                { label: '12:30 PM' , value: '12:30:00'},
                { label: '1:00 PM'  , value: '13:00:00'},
                { label: '1:30 PM'  , value: '13:30:00'},
                { label: '2:00 PM'  , value: '14:00:00'},
                { label: '2:30 PM'  , value: '14:30:00'},
                { label: '3:00 PM'  , value: '15:00:00'},
                { label: '3:30 PM'  , value: '15:30:00'},
                { label: '4:00 PM'  , value: '16:00:00'},
                { label: '4:30 PM'  , value: '16:30:00'},
                { label: '5:00 PM'  , value: '17:00:00'},
                { label: '5:30 PM'  , value: '17:30:00'},
                { label: '6:00 PM'  , value: '18:00:00'},
                { label: '6:30 PM'  , value: '18:30:00'},
                { label: '7:00 PM'  , value: '19:00:00'},
                { label: '7:30 PM'  , value: '19:30:00'},
                { label: '8:00 PM'  , value: '20:00:00'},
                { label: '8:30 PM'  , value: '20:30:00'},
                { label: '9:00 PM'  , value: '21:00:00'},
                { label: '9:30 PM'  , value: '21:30:00'},
                { label: '10:00 PM' , value: '22:00:00'}
              ],
              mapping: 'startTime'
            }
          ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Number of Guests: *',
              mapping: 'plannedguestcount'
            }
          ]
        },
        {
          fields: [
            {
              type: 'checkbox-list',
              size: 'Medium',
              label: 'Will Your Event be At Blue Ridge Cafe or Off Site?',
              options: [
                { label: 'Blue Ridge Cafe Banquet Room' , value: 'Blue Ridge Cafe Banquet Room'},
                { label: 'Off Site' , value: 'Off Site'}     
              ],
              mapping: 'eventExtra1',
              customClasses: ['check-columns']
            }
          ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'If Off Site What Venue Will Your Event Be Held At? *',
              mapping: 'eventExtra2'
            }
          ]
        },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Style of Catering',
            options: [
              { label: 'Pickup' , value: 'Pickup'},
              { label: 'Delivery: Delivery and Set up', value: 'Delivery: Delivery and Set up'},
              { label: 'Full Service Catering', value: 'Full Service Catering'}
            ],
            mapping: 'category'
          }
        ]
      },

      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Will you need Staff?',
            options: [
              { label: 'Yes' , value: 'Yes'},
              { label: 'No', value: 'No'}
            ],
            mapping: 'eventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Information:',
            mapping: 'notes',
            customClasses: ['header2']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Blue Ridge Cafe & Catering Co Contact Us Form',
    formId: '514',
    clientKey: 'A7FEFDBE-3BE3-4D17-A9C8-A1CA82FDE572',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/blueridgecafe/form_structure.js